<div class="login-page-wrapper">
  <span class="branding-logo">
    <img
      (click)="navigateToHome()"
      class="logo"
      src="assets/images/lightup-main-logo.png"
      alt="The Lightup Hub logo"
    />
  </span>
  <div class="container" #loginContainer>
    <div class="form-container sign-up-container" #signupContainer>
      <form
        class="sign-up-form"
        (ngSubmit)="register()"
        [formGroup]="signupForm"
      >
        <h1>Sign up</h1>

        @if (planSelected) {
          <h4>Almost there - create your account to get started</h4>

          <p class="pay-text">Payment will be taken on the next step.</p>
        }

        <div class="social-container">
          <div class="social-button-container">
            <app-button
              [fullWidth]="true"
              variant="outline"
              class="social-btn"
              size="sm"
              [disabled]="isLoading"
              (click)="googleSignUp()"
              data-testid="google-signup-btn"
            >
              <span class="button-content">
                Sign up using Google
                <span>
                  <img
                    class="social-icon"
                    src="assets/images/google-icon.png"
                    alt=""
                  />
                </span>
              </span>
            </app-button>
          </div>
          <!-- <div class="social-button-container">
            <app-button
              [fullWidth]="true"
              variant="outline"
              class="social-btn"
              size="sm"
              (click)="appleSignUp()"
            >
              <span class="button-content">
                Sign up using Apple
                <span>
                  <img
                    class="social-icon apple"
                    src="assets/images/apple-icon.png"
                    alt=""
                  />
                </span>
              </span>
            </app-button>
          </div> -->
          <div class="social-button-container">
            <app-button
              [fullWidth]="true"
              variant="outline"
              class="social-btn"
              size="sm"
              (click)="showSignupForm()"
              data-testid="signup-open-email-form-btn"
            >
              <span class="button-content">
                Sign up using email
                <span>
                  <img
                    class="social-icon apple"
                    src="assets/images/email-icon.png"
                    alt=""
                  />
                </span>
              </span>
            </app-button>
          </div>
        </div>

        <div class="signup-form">
          <a class="show-other" (click)="hideSignupForm()"
          >See other signup methods</a
          >

          <input
            id="firstName"
            type="text"
            placeholder="First name"
            formControlName="firstName"
            data-testid="signup-firstname-input"
          />
          @if (
            signupForm.get("firstName")?.invalid &&
            signupForm.get("firstName")?.dirty
            ) {
            <span class="form-error">First name is required.</span>
          }

          <input
            id="email"
            type="email"
            placeholder="Email"
            formControlName="email"
            data-testid="signup-email-input"
          />

          @if (
            signupForm.get("email")?.errors?.["required"] &&
            (signupForm.get("email")?.dirty || signupForm.get("email")?.touched)
            ) {
            <span class="form-error">Email is required.</span>
          }
          @if (
            signupForm.get("email")?.errors?.["email"] &&
            (signupForm.get("email")?.dirty || signupForm.get("email")?.touched)
            ) {
            <span class="form-error">Please enter a valid email.</span>
          }

          <div class="input-wrapper">
            <input
              id="password"
              [type]="showPassword ? 'text' : 'password'"
              placeholder="Password"
              formControlName="password"
              class="password-input"
              autocomplete="off"
              data-testid="signup-password-input"
            />
            <span
              (click)="toggleShowPassword()"
              class="show-password"
              GenerateIdentifier="show-password-btn"
            >
              <span class="material-symbols-outlined icon">
                {{ showPassword ? "visibility_off" : "visibility" }}
              </span>
            </span>
          </div>
          <div class="input-wrapper">
            <input
              id="confirm-password"
              [type]="showConfirmPassword ? 'text' : 'password'"
              placeholder="Confirm password"
              formControlName="confirmPassword"
              class="password-input"
              autocomplete="off"
              data-testid="signup-confirm-password-input"
            />
            <span
              (click)="toggleShowConfirmPassword()"
              class="show-password"
              GenerateIdentifier="show-password-btn"
            >
              <span class="material-symbols-outlined icon">
                {{ showConfirmPassword ? "visibility_off" : "visibility" }}
              </span>
            </span>
          </div>

          @if (
            signupForm.get("password")?.errors?.["required"] &&
            (signupForm.get("password")?.dirty ||
              signupForm.get("password")?.touched)
            ) {
            <span class="form-error">Password is required.</span>
          }
          @if (
            signupForm.get("password")?.errors?.["minlength"] &&
            (signupForm.get("password")?.dirty ||
              signupForm.get("password")?.touched)
            ) {
            <span class="form-error"
            >Password must be at least 6 characters.</span
            >
          }

          @if (
            signupForm.errors?.["passwordMismatch"] &&
            (signupForm.get("confirmPassword")?.dirty ||
              signupForm.get("confirmPassword")?.touched)
            ) {
            <span class="form-error">Passwords do not match.</span>
          }

          <div class="checkbox-container">
            <mat-checkbox (change)="onCheckboxChange($event)"></mat-checkbox>
            <label> Sign up for offers and updates</label>
          </div>

          @if (formError) {
            <span class="form-error" data-testid="signup-form-error">{{ formError }}</span>
          }

          <button
            [GenerateIdentifier]="
              selectedPlan
                ? selectedPlan.title + '_create-account-btn'
                : 'no-plan-selected-create-account-btn'
            "
            [disabled]="signupForm.invalid || isLoading"
            id="signUp"
            type="submit"
            data-testid="signup-submit-btn"
          >
            @if (isLoading) {
              <app-loading-spinner
                [message]="'Creating account...'"
                [diameter]="25"
              ></app-loading-spinner>
            } @else {
              Create Account
            }
          </button>
        </div>
      </form>
    </div>

    <div class="form-container sign-in-container">
      <form [formGroup]="loginForm" (ngSubmit)="login()" class="sign-in-form">
        <h1>Sign in</h1>
        <div class="social-container">
          <div class="social-button-container">
            <app-button
              [fullWidth]="true"
              variant="outline"
              class="social-btn"
              size="sm"
              [disabled]="isLoading"
              (click)="googleSignIn()"
              data-testid="google-signin-btn"
            ><span class="button-content"
            >Sign in with Google<span
            ><img
              class="social-icon"
              src="assets/images/google-icon.png"
              alt="" /></span
            ></span>
            </app-button>
          </div>
          <!-- <div class="social-button-container">
            <app-button
              [fullWidth]="true"
              variant="outline"
              class="social-btn"
              size="sm"
              (click)="appleSignIn()"
              ><span class="button-content"
                >Sign in with Apple<span
                  ><img
                    class="social-icon apple"
                    src="assets/images/apple-icon.png"
                    alt="" /></span
              ></span>
            </app-button>
          </div> -->
        </div>
        <span>or use your account</span>
        <input
          type="email"
          placeholder="Email"
          formControlName="email"
          data-testid="login-email-input"
        />
        <div class="input-wrapper">
          <input
            [type]="showPassword ? 'text' : 'password'"
            placeholder="Password"
            formControlName="password"
            class="password-input"
            autocomplete="off"
            data-testid="login-password-input"
          />
          <span
            (click)="toggleShowPassword()"
            class="show-password"
            GenerateIdentifier="show-password-btn"
          >
            <span class="material-symbols-outlined icon">
              {{ showPassword ? "visibility_off" : "visibility" }}
            </span>
          </span>
        </div>
        <span class="forgot-password-container">
          <span (click)="forgotPassword()" class="forgot-password-link"
          >Forgot your password?</span
          >
        </span>
        @if (formError) {
          <span class="form-error" data-testid="login-form-error">{{ formError }}</span>
        }
        <button
          [disabled]="loginForm.invalid || isLoading"
          id="signIn"
          type="submit"
          data-testid="login-submit-btn"
        >
          @if (isLoading) {
            <app-loading-spinner
              [message]="'Signing in...'"
              [diameter]="25"
            ></app-loading-spinner>
          } @else {
            Sign In
          }
        </button>
      </form>
    </div>
    <div class="overlay-container">
      <div class="overlay">
        <div class="overlay-panel overlay-left">
          @if (planSelected && selectedPlan) {
            <span>You’ve chosen the</span>
            <app-card class="selected-plan-card">
              <div class="offer-container">
                @if (selectedPlan.offer_text) {
                  <span class="overlay-offer">{{
                      selectedPlan.offer_text
                    }}</span>
                }
              </div>
              <div class="plan-content">
                <h3 class="plan-title">{{ selectedPlan.title }}</h3>
                @if (selectedPlan.description) {
                  <span class="plan-text">
                    <div [innerHTML]="selectedPlan.description"></div>
                  </span>
                }
                <!-- ONE OFF -->
                @if (selectedPlan.billing_period === "one_off") {
                  @if (+selectedPlan.price_per_month > 0) {
                    <span class="plan-price">
                      @if (selectedPlan.rrp) {
                        <span class="old-price">£{{ selectedPlan.rrp }}</span>
                      }
                      <span class="price"
                      >£{{ selectedPlan.price_per_month }} </span
                      >/Month
                    </span>
                    <span class="plan-text">
                      Paid as a single payment of
                      <span class="plan-price">
                        <span class="price">£{{ selectedPlan.amount }}</span>
                      </span>
                    </span>
                    now
                  } @else {
                    <span class="plan-text">
                      Just
                      <span class="plan-price">
                        <span class="price">£{{ selectedPlan.amount }}</span>
                      </span>
                    </span>
                  }
                }
                <!-- / ONE OFF -->
                <!-- RECURRING -->
                @else {
                  <span class="plan-price">
                    @if (selectedPlan.rrp) {
                      <span class="old-price">£{{ selectedPlan.rrp }}</span>
                    }
                    @if (+selectedPlan.price_per_month > 0) {
                      <span class="price">
                        £{{ selectedPlan.price_per_month }} </span
                      >/mth
                    }
                  </span>
                  <span class="plan-text">
                    Billing period: {{ selectedPlan.period_label }} at
                    <span class="plan-price">
                      <span class="price">£{{ selectedPlan.amount }}</span>
                    </span>
                  </span>
                }
                <!-- / RECURRING -->
              </div>
            </app-card>

            <h4 class="already-have-an-account">Already have an account?</h4>
            <p>
              If you already have an account, please login by clicking below
            </p>
            <button class="ghost" id="signUp" (click)="showLoginPage()">
              Sign In
            </button>
          } @else {
            <h3>Already have an account?</h3>
            <p>
              If you already have an account, please login by clicking below
            </p>
            <button class="ghost" id="signUp" (click)="showLoginPage()">
              Sign In
            </button>
          }
        </div>
        <div class="overlay-panel overlay-right">
          <h3>Not a member yet?</h3>
          <p>Register now and start your journey with us</p>
          <div class="button-container">
            <button
              class="ghost"
              id="signUp"
              (click)="showSignupPage()"
              data-testid="signup-panel-toggle-btn"
            >
              Sign Up
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
